(function () {
  function initStickyThumbnails() {
    const controls = document.querySelector(
      '.media-gallery--carousel slideshow-controls'
    );
    if (!controls) return;

    Object.assign(controls.style, {
      position: 'sticky',
      top: '20px',
      alignSelf: 'flex-start',
      height: 'fit-content',
      zIndex: '2',
      overflow: 'visible'
    });

    const scrollHint = controls.querySelector('scroll-hint');
    if (scrollHint) {
      Object.assign(scrollHint.style, {
        overflow: 'visible',
        maskImage: 'none',
        webkitMaskImage: 'none'
      });
    }

    const slideshowComponent = controls.closest('slideshow-component');
    if (slideshowComponent) {
      slideshowComponent.style.overflow = 'visible';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyThumbnails);
  } else {
    initStickyThumbnails();
  }

  document.addEventListener('page:load', initStickyThumbnails);
  document.addEventListener('shopify:section:load', initStickyThumbnails);
})();